const SPARK_BUTTON_TROLLEYS = {
  "xmas-poinsettia-2": [
    {
      sku: "HO-431A-101",
      absoluteQuantity: 30,
    },
    {
      sku: "HO-386A-102",
      absoluteQuantity: 16,
    },
    {
      sku: "HO-386A-104",
      absoluteQuantity: 20,
    },
    {
      sku: "HO-387A-101",
      absoluteQuantity: 12,
    },
    {
      sku: "HO-387A-102",
      absoluteQuantity: 24,
    },
    {
      sku: "HO-433A-101",
      absoluteQuantity: 6,
    },
    {
      sku: "HO-433A-102",
      absoluteQuantity: 6,
    },
    {
      sku: "HO-386A-103",
      absoluteQuantity: 8,
    },
  ],
  "xmas-mix-1": [
    {
      sku: "HO-363C-101",
      absoluteQuantity: 10,
    },
    {
      sku: "HO-426C-102",
      absoluteQuantity: 10,
    },
    {
      sku: "HO-377C-102",
      absoluteQuantity: 6,
    },
    {
      sku: "HO-362C-101",
      absoluteQuantity: 8,
    },
    {
      sku: "HO-389C-101",
      absoluteQuantity: 8,
    },
    {
      sku: "HO-309C-102",
      absoluteQuantity: 6,
    },
    {
      sku: "HO-374C-101",
      absoluteQuantity: 8,
    },
    {
      sku: "HO-377C-101",
      absoluteQuantity: 12,
    },
    {
      sku: "HO-376C-102",
      absoluteQuantity: 6,
    },
    {
      sku: "HO-438C-101",
      absoluteQuantity: 2,
    },
    {
      sku: "HO-376C-101",
      absoluteQuantity: 8,
    },
    {
      sku: "HO-437C-101",
      absoluteQuantity: 4,
    },
  ],
  "XXL-Hydro-1": [
    {
      sku: "HO-478A-101",
      absoluteQuantity: 2,
    },
    {
      sku: "HO-478A-102",
      absoluteQuantity: 2,
    },
    {
      sku: "HO-300A-109",
      absoluteQuantity: 2,
    },
    {
      sku: "HO-480A-101",
      absoluteQuantity: 2,
    },
    {
      sku: "HO-480A-102",
      absoluteQuantity: 2,
    },
    {
      sku: "HO-481A-103",
      absoluteQuantity: 1,
    },
    {
      sku: "HO-482A-101",
      absoluteQuantity: 2,
    },
  ],
  "xmas-poinsettia-7": [
    {
      sku: "HO-387A-101",
      absoluteQuantity: 18,
    },
    {
      sku: "HO-387A-102",
      absoluteQuantity: 30,
    },
    {
      sku: "HO-386A-102",
      absoluteQuantity: 16,
    },
    {
      sku: "HO-386A-104",
      absoluteQuantity: 20,
    },
    {
      sku: "HO-386A-103",
      absoluteQuantity: 8,
    },
    {
      sku: "HO-431A-101",
      absoluteQuantity: 30,
    },
    {
      sku: "HO-386A-101",
      absoluteQuantity: 24,
    },
  ],
  "spring-green-17": [
    {
      sku: "HO-330A-101",
      absoluteQuantity: 24,
    },
    {
      sku: "HO-366A-101",
      absoluteQuantity: 12,
    },
    {
      sku: "HO-487A-101",
      absoluteQuantity: 6,
    },
    {
      sku: "HO-461A-101",
      absoluteQuantity: 12,
    },
    {
      sku: "HO-349A-101",
      absoluteQuantity: 12,
    },
    {
      sku: "HO-493A-101",
      absoluteQuantity: 6,
    },
  ],
  "trolley-offer-3": [
    {
      sku: "HO-472A-101",
      absoluteQuantity: 12,
    },
    {
      sku: "HO-376A-135",
      absoluteQuantity: 12,
    },
    {
      sku: "HO-329A-102",
      absoluteQuantity: 12,
    },
    {
      sku: "HO-361A-102",
      absoluteQuantity: 12,
    },
    {
      sku: "HO-366A-102",
      absoluteQuantity: 6,
    },
    {
      sku: "HO-360A-104",
      absoluteQuantity: 12,
    },
    {
      sku: "HO-363A-105",
      absoluteQuantity: 12,
    },
    {
      sku: "HO-389A-106",
      absoluteQuantity: 12,
    },
    {
      sku: "HO-362A-110",
      absoluteQuantity: 12,
    },
    {
      sku: "HO-308A-105",
      absoluteQuantity: 12,
    },
    {
      sku: "HO-319A-101",
      absoluteQuantity: 3,
    },
    {
      sku: "HO-344A-109",
      absoluteQuantity: 6,
    },
  ],
  "trolley-special-offer": [
    {
      sku: "HO-410A-101",
      absoluteQuantity: 6,
    },
    {
      sku: "HO-360A-101",
      absoluteQuantity: 12,
    },
    {
      sku: "HO-472A-101",
      absoluteQuantity: 12,
    },
    {
      sku: "HO-376A-149",
      absoluteQuantity: 12,
    },
    {
      sku: "HO-463A-101",
      absoluteQuantity: 6,
    },
    {
      sku: "HO-329A-101",
      absoluteQuantity: 12,
    },
    {
      sku: "HO-352A-101",
      absoluteQuantity: 12,
    },
    {
      sku: "HO-553A-101",
      absoluteQuantity: 3,
    },
    {
      sku: "HO-389A-101",
      absoluteQuantity: 12,
    },
    {
      sku: "HO-532A-101",
      absoluteQuantity: 10,
    },
    {
      sku: "HO-363A-114",
      absoluteQuantity: 12,
    },
    {
      sku: "HO-595A-101",
      absoluteQuantity: 6,
    },
    {
      sku: "HO-344A-106",
      absoluteQuantity: 8,
    },
    {
      sku: "HO-315A-103",
      absoluteQuantity: 12,
    },
    {
      sku: "HO-314A-107",
      absoluteQuantity: 20,
    },
    {
      sku: "HO-314A-102",
      absoluteQuantity: 20,
    },
    {
      sku: "HO-346A-104",
      absoluteQuantity: 24,
    },
    {
      sku: "HO-346A-102",
      absoluteQuantity: 12,
    },
    {
      sku: "HO-346A-101",
      absoluteQuantity: 12,
    },
    {
      sku: "HO-499A-101",
      absoluteQuantity: 2,
    },
    {
      sku: "HO-317A-104",
      absoluteQuantity: 8,
    },
    {
      sku: "HO-308A-101",
      absoluteQuantity: 12,
    },
    {
      sku: "HO-500A-101",
      absoluteQuantity: 8,
    },
  ],
  "christmas-poinsettia-1": [
    {
      sku: "HO-387A-104",
      absoluteQuantity: 128,
    },
  ],
  "christmas-poinsettia-2": [
    {
      sku: "HO-387C-101",
      absoluteQuantity: 32,
    },
    {
      sku: "HO-387A-104",
      absoluteQuantity: 64,
    },
    {
      sku: "HO-432A-101",
      absoluteQuantity: 24,
    },
  ],
  "essential-green-plant-trolley": [
    {
      sku: "HO-360P-106",
      absoluteQuantity: 30,
    },
    {
      sku: "HO-682P-102",
      absoluteQuantity: 22,
    },
  ],
  "Premium-green-plant-trolley": [
    {
      sku: "HO-360P-106",
      absoluteQuantity: 30,
    },
    {
      sku: "HO-682P-101",
      absoluteQuantity: 22,
    },
  ],
  "christmas-poinsettia-3": [
    {
      sku: "HO-387C-101",
      absoluteQuantity: 32,
    },
    {
      sku: "HO-387A-104",
      absoluteQuantity: 48,
    },
    {
      sku: "HO-432A-101",
      absoluteQuantity: 12,
    },
    {
      sku: "HO-387A-101",
      absoluteQuantity: 12,
    },
    {
      sku: "HO-432C-101",
      absoluteQuantity: 6,
    },
  ],
  "christmas-starter-trolley": [
    {
      sku: "HO-623C-101",
      absoluteQuantity: 3,
    },
    {
      sku: "HO-377C-103",
      absoluteQuantity: 6,
    },
    {
      sku: "HO-375C-102",
      absoluteQuantity: 4,
    },
    {
      sku: "HO-376C-101",
      absoluteQuantity: 12,
    },
    {
      sku: "HO-644C-101",
      absoluteQuantity: 4,
    },
    {
      sku: "HO-658C-101",
      absoluteQuantity: 4,
    },
    {
      sku: "HO-637C-101",
      absoluteQuantity: 6,
    },
    {
      sku: "HO-377C-101",
      absoluteQuantity: 12,
    },
    {
      sku: "HO-475C-101",
      absoluteQuantity: 8,
    },
    {
      sku: "HO-642C-101",
      absoluteQuantity: 4,
    },
    {
      sku: "HO-649C-102",
      absoluteQuantity: 12,
    },
    {
      sku: "HO-532C-101",
      absoluteQuantity: 8,
    },
    {
      sku: "HO-426C-102",
      absoluteQuantity: 9,
    },
    {
      sku: "HO-639C-101",
      absoluteQuantity: 12,
    },
    {
      sku: "HO-471C-103",
      absoluteQuantity: 16,
    },
    {
      sku: "HO-654C-101",
      absoluteQuantity: 30,
    },
  ],
};

const sparkButtonCallback = (name) => {
  window.spark.updateCart({
    products: SPARK_BUTTON_TROLLEYS[name],
  });
};
